<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-08-28 14:43:41
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-12-20 16:33:56
 * @FilePath: \合联\oms\src\view\commissionManagement\commissionDetails\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/commissionManagement/commissionDetails";
export default {
  name: "commissionDetails",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "sale_id",
            placeholder() {
              return this.$tz("销售名称");
            },
            component: "Select",
            options: [],
            optionsFn: "salesman",
            optionsKey: ""
          },
          {
            key: "date",
            placeholder() {
              return this.$tz("请选择,日期");
            },
            component: "DatePicker",
            format: "YYYY-MM",
            disabledDate: true,

            bind: {
              type: "month",
              style: {
                width: "150px"
              }
            }
          }
        ],
        btns: {
          list: [],
          methods: {}
        }
      },
      fields: [
        {
          name: () => this.$t("salesman"),
          key: "sale_name",
          minWidth: 130
        },
        {
          name: () => this.$tz("提成,日期"),
          key: "date",
          minWidth: 130
        },
        {
          name: () => this.$tz("国际,小包"),
          key: "international_num",
          minWidth: 130
        },
        {
          name: () => this.$tz("国际,小包,任务"),
          key: "international_task_num",
          minWidth: 130
        },
        {
          name: () => this.$tz("中东,本地,小包"),
          key: "local_num",
          minWidth: 130
        },
        {
          name: () => this.$tz("中东,本地,小包,任务"),
          key: "local_task_num",
          minWidth: 130
        },
        {
          name: () => this.$tz("以色列,小包"),
          key: "israel_num",
          minWidth: 130
        },
        {
          name: () => this.$tz("以色列,小包,任务"),
          key: "israel_task_num",
          minWidth: 130
        },
        {
          name: () => this.$tz("双清,收入"),
          key: "dbl_income",
          minWidth: 130
        },
        {
          name: () => this.$tz("双清,成本"),
          key: "dbl_cost",
          minWidth: 130
        },
        {
          name: () => this.$tz("双清,任务"),
          key: "dbl_task",
          minWidth: 130
        },
        {
          name: () => this.$tz("个人,提成"),
          key: "personal_income",
          minWidth: 130
        },
        {
          name: () => this.$tz("管理,提成"),
          key: "manage_income",
          minWidth: 130
        },
        {
          name: () => this.$tz("提成,详情,文件"),
          key: "src",
          minWidth: 130,
          component: "Button",
          bind: {
            size: "small",
            type: "primary"
          },
          disabled: ({ value }) => !value,
          methods: {
            render() {
              return this.$tz("下载");
            },
            click({ value }) {
              this.$page.openUrl(value);
            }
          }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
